import MinusIcon from '@/fo/icons/base/icons/minus.svg';
import PlusIcon from '@/fo/icons/base/icons/plus.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './Controls.styles';
interface ControlsProps {
  onClick: (zoom: number) => void;
}

export function Controls({ onClick }: ControlsProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <UiKitButtonBase
        color="secondary"
        className={slots.control()}
        onClick={() => onClick(1)}
      >
        <PlusIcon className={slots.icon()} />
      </UiKitButtonBase>
      <UiKitButtonBase
        color="secondary"
        className={slots.control()}
        onClick={() => onClick(-1)}
      >
        <MinusIcon className={slots.icon()} />
      </UiKitButtonBase>
    </div>
  );
}
